import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  makeStyles,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteMarca,
  getMarcaById,
  postMarca,
  updateMarca,
} from "../../../../api/marca";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { Autocomplete } from "@material-ui/lab";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));
function removeAccents(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export default function EditMarcaPage() {
  const [marca, setMarca] = useState({
    active: true,
    nombre: "",
    discountPercent: 0,
    prioritaria: false,
    scrapingPercent: 0,
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const marcaId = useParams().id;
  const classes = useStyles();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        if (marcaId) {
          getMarcaById(marcaId)
            .then((resMarca) => {
              if (resMarca.status === 200) {
                setMarca(resMarca.data);
              }
            })
            .catch((error) => {
              setLoading(false);
              alertError({
                error,
                customMessage: "Could not get marca details.",
              });
              history.push("/marcas");
            });
        }
      } catch (error) {
        setLoading(false);
        alertError({ error: error });
      }
    };

    fetchData();
    setLoading(false);
  }, [marcaId, history]);

  const handleChange = (field) => (event) => {
    setMarca({ ...marca, [field]: event.target.value });
  };

  const handleNumberChange = (field) => (event) => {
    const raw = event.target.value;
    const num = raw === "" ? "" : Number(raw);
    setMarca({ ...marca, [field]: num });
  };

  const handleSave = () => {
    // Validate discountPercent before saving
    const dp = Number(marca.discountPercent);
    if (isNaN(dp) || dp < 0 || dp > 100) {
      alertError({ customMessage: "Descuento % debe estar entre 0 y 100" });
      return;
    }
    marca.discountPercent = dp;

    // Validate scrapingPercent if marca is prioritaria
    if (marca.prioritaria) {
      const sp = Number(marca.scrapingPercent || 0);
      if (isNaN(sp) || sp < 0 || sp > 100) {
        alertError({ customMessage: "Porcentaje Scraping % debe estar entre 0 y 100" });
        return;
      }
      marca.scrapingPercent = sp;
    } else {
      marca.scrapingPercent = 0;
    }

    if (!marcaId) {
      postMarca(marca)
        .then(() => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Marca saved successfully.",
          });
          history.push("/marcas");
        })
        .catch((error) => {
          alertError({
            error,
            customMessage: "Could not save marca details.",
          });
        });
    } else {
      updateMarca(marcaId, marca)
        .then(() => {
          alertSuccess({
            title: "Saved!",
            customMessage: "Marca saved successfully.",
          });
          history.push("/marcas");
        })
        .catch((error) => {
          alertError({
            error,
            customMessage: "Could not save marca details.",
          });
        });
    }
  };

  return (
    <>
      <Card>
        <CardHeader title="Edit Marca" />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <CircularProgress className={classes.fancyLoader} />
          </div>
        ) : (
          <CardBody>
            <div className="row d-flex align-items-center">
              <div className="col-md-4">
                <TextField
                  label="Nombre"
                  value={marca.nombre}
                  onChange={handleChange("nombre")}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
              <div className="col-md-4">
                <TextField
                  label="Descuento %"
                  value={marca.discountPercent}
                  onChange={handleNumberChange("discountPercent")}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  type="number"
                  inputProps={{ min: 0, max: 100, step: 0.01 }}
                  helperText="Valor entre 0 y 100"
                />
              </div>
            </div>
            <br />
            <div className="row d-flex align-items-center">
              <div className="col-md-4">
                <TextField
                  label="Porcentaje Scraping %"
                  value={marca.scrapingPercent || 0}
                  onChange={handleNumberChange("scrapingPercent")}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  type="number"
                  inputProps={{ min: 0, max: 100, step: 0.01 }}
                  helperText="Porcentaje de créditos para scraping (solo si es prioritaria)"
                  disabled={!marca.prioritaria}
                />
              </div>
            </div>
            <br />
            <FormControlLabel
              control={
                <Checkbox
                  checked={marca.active}
                  onChange={() => setMarca({ ...marca, active: !marca.active })}
                />
              }
              label="Active"
            />
            <br />
            <FormControlLabel
              control={
                <Checkbox
                  checked={marca.prioritaria || false}
                  onChange={() => {
                    const newPrioritaria = !marca.prioritaria;
                    setMarca({ 
                      ...marca, 
                      prioritaria: newPrioritaria,
                      scrapingPercent: newPrioritaria ? (marca.scrapingPercent || 0) : 0
                    });
                  }}
                />
              }
              label="Marca Prioritaria"
            />
          </CardBody>
        )}
      </Card>
      <Button
        onClick={() => history.push("/marcas")}
        variant="outlined"
        style={{ marginRight: "20px" }}
      >
        Back
      </Button>
      <Button
        onClick={handleSave}
        variant="outlined"
        color="primary"
        style={{ marginRight: "20px" }}
      >
        Save
      </Button>
      {marcaId && (
        <>
          <MuiThemeProvider theme={theme}>
            <Button
              onClick={() => setOpenConfirmDialog(true)}
              variant="outlined"
              color="secondary"
            >
              Delete
            </Button>
          </MuiThemeProvider>

          <ConfirmDialog
            title={"Are you sure you want to delete this watch?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteMarca(marcaId, marca)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Delete successfully.",
                    });
                    history.push("/marcas");
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not save changes.",
                  });
                });
            }}
          />
        </>
      )}
    </>
  );
}
